import { RulerStrip } from "../Marks";
import { Reveal } from "../Reveal";

export const AboutLine = () => (
  <section
    data-testid="section-about-line"
    className="relative overflow-hidden border-b border-[#e2e2da] bg-[#f8f8f5] px-5 py-20 text-[#0a0a0a] sm:px-8 sm:py-28"
  >
    <div
      aria-hidden="true"
      className="halftone pointer-events-none absolute -left-10 top-0 h-48 w-64 text-[#0a58ca]"
    />
    <div className="relative mx-auto max-w-[1600px]">
      <RulerStrip color="#cfcfc4" />
      <Reveal>
        <p className="mt-10 max-w-5xl font-display text-2xl font-extrabold uppercase leading-[1.12] tracking-tight sm:text-3xl lg:text-[2.6rem]">
          No Glyph Studios is a full-service apparel printing and production art
          studio helping artists, creators, businesses, and organizations turn
          ideas and original artwork into{" "}
          <span style={{ color: "var(--ng-blue)" }}>
            professionally printed apparel and merchandise
          </span>
          .
        </p>
      </Reveal>
    </div>
  </section>
);
